import React, { useEffect } from "react"
import Layout from "../../components/layout"

function Page() {
  useEffect(() => {
    window.location.href =
      "https://forms.zohopublic.com/csglearninginstitute/form/CSGLearningOnlineCAPEClassesApplicationForm/formperma/EpHVpMQujkMld8uNEtB9yPtC14uHFdAB4pFA2-pt8Cw"
  }, [])

  return (
    <Layout hideAlert>
      <div className="container">
        <br />
        <h3>You're being redirected. Please wait...</h3>
      </div>
    </Layout>
  )
}

export default Page
